import { render, staticRenderFns } from "./identify_teacher.vue?vue&type=template&id=f4733b0c&scoped=true&"
import script from "./identify_teacher.vue?vue&type=script&lang=js&"
export * from "./identify_teacher.vue?vue&type=script&lang=js&"
import style0 from "./identify_teacher.vue?vue&type=style&index=0&id=f4733b0c&prod&lang=less&scoped=scoped&"
import style1 from "./identify_teacher.vue?vue&type=style&index=1&id=f4733b0c&prod&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4733b0c",
  null
  
)

export default component.exports